import { ColumnType } from '@dynamika-shared/ui/Table/Table.types';
import React from 'react';
import { TruncatedText } from '@dynamika-shared/ui/TruncatedText/TruncatedText';
import { SupportSubjectType } from '@dynamika-shared/types/subjects';
import { Button } from '@dynamika-shared/ui/Button/Button';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';
import { MakeSupportSubjectListColumnsType } from './common/types';
import { formatDate } from './common/renderers';

export function makeSupportSubjectListColumns(
  props?: MakeSupportSubjectListColumnsType
): ColumnType<SupportSubjectType>[] {
  return [
    {
      name: 'code',
      tdClassName: 'w-[210px]',
      hasSorting: true,
      header() {
        return 'Subject ID';
      },

      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row) {
        return <TruncatedText text={row.patientCode} truncate tooltip />;
      },
    },
    {
      name: 'birthDate',
      tdClassName: 'w-[190px]',
      hasSorting: true,
      header() {
        return 'Date of Birth';
      },
      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row) {
        return <div className=''>{formatDate(row?.patientDob)}</div>;
      },
    },
    {
      name: 'cohort',
      tdClassName: 'w-[210px]',
      hasSorting: true,
      header() {
        return 'Cohort';
      },

      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row) {
        return <div className=''>{row?.cohortName}</div>;
      },
    },
    {
      name: 'siteCode',
      tdClassName: 'w-[210px]',
      hasSorting: true,
      header() {
        return 'Site Code';
      },

      loading: () => (
        <div className='h-2 w-10 animate-pulse rounded-md bg-slate-300'></div>
      ),
      getValue(row) {
        return <div className=''>{row?.siteCode}</div>;
      },
    },
    {
      name: 'actions',
      hasSorting: true,
      header() {
        return 'Action';
      },
      loading: () => (
        <div className='h-3 w-3 animate-pulse rounded-md bg-brightGray'></div>
      ),
      getValue(row) {
        return (
          <Button
            type='text'
            onClick={() => props?.onSubjectClick?.(row)}
            className='flex h-4 !min-h-fit w-4 cursor-pointer items-center justify-center !p-0'
          >
            <ChevronIcon dir='right' className='h-2 w-2 text-pastelBlue' />
          </Button>
        );
      },
      alignToRight: true,
      cellClassName: 'min-w-[5.7rem]',
      thClassName: 'w-[10rem] z-10',
    },
  ];
}
